<template>
  <div>
    <b-loading
      :is-full-page="isFullPage"
      :active.sync="isLoading"
      :can-cancel="false"
    ></b-loading>
    <h4 class="title is-4">{{ createOrUpdate }}</h4>
    <div class="columns">
      <div class="column">
        <div class="field">
          <label class="label is-small">Firstname</label>
          <div class="control">
            <input
              type="text"
              class="input is-small"
              v-model="user.firstname"
            />
          </div>
        </div>
        <div class="field">
          <label class="label is-small">Lastname</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="user.lastname" />
          </div>
        </div>
        <div class="field">
          <label class="label is-small"
            >Employee ID (Main ID from Payroll System)</label
          >
          <div class="control">
            <input
              type="number"
              class="input is-small"
              v-model="user.employeeId"
            />
          </div>
        </div>
        <div class="field">
          <label class="label is-small">Email</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="user.email" />
          </div>
        </div>
        <div class="field">
          <label class="label is-small">Email Password</label>
          <div class="control">
            <div v-if="isCreate">
              <div class="control">
                <input
                  type="password"
                  class="input is-small"
                  v-model="user.emailPassword"
                />
              </div>
            </div>
            <div v-else>
              <div class="columns">
                <div class="column">
                  <input
                    type="password"
                    class="input is-small"
                    v-model="replaceEmailPass.newPassword"
                  />
                </div>
                <div class="column">
                  <button class="button is-small" @click="replaceEmailPassword">
                    Change Email Password
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="field">
          <label class="label is-small">Username</label>
          <div class="control">
            <input type="text" class="input is-small" v-model="user.userName" />
          </div>
        </div>
        <div v-if="isCreate">
          <div class="field">
            <label class="label is-small">Password</label>
            <div class="control">
              <input
                type="password"
                class="input is-small"
                v-model="user.password"
              />
            </div>
          </div>
          <div class="field">
            <label class="label is-small">Confirm Password</label>
            <div class="control">
              <input type="password" class="input is-small" />
            </div>
          </div>
          <div style="display: block"></div>
        </div>
        <div v-else>
          <div class="field is-small">
            <label class="label is-small">Replace Password</label>
            <div class="columns">
              <div class="column">
                <input
                  type="password"
                  class="input is-small"
                  v-model="replacePass.newPassword"
                />
              </div>
              <div class="column">
                <button class="button is-small" @click="replacePassword">
                  Replace Password
                </button>
              </div>
            </div>
          </div>
          <div style="display: block"></div>
        </div>
        <div class="field">
          <label class="label is-small">Role(s)</label>
          <div class="control">
            <b-checkbox
              v-model="userRolesForCheckbox"
              native-value="Main Admin"
              size="is-small"
            >
              Main Admin
            </b-checkbox>
            <b-checkbox
              v-model="userRolesForCheckbox"
              native-value="Admin Sales"
              size="is-small"
            >
              Admin Sales
            </b-checkbox>
            <b-checkbox
              v-model="userRolesForCheckbox"
              native-value="Admin Purchaser"
              size="is-small"
            >
              Admin Purchaser
            </b-checkbox>
            <b-checkbox
              v-model="userRolesForCheckbox"
              native-value="Admin Marketing"
              size="is-small"
            >
              Admin Marketing
            </b-checkbox>
            <b-checkbox
              v-model="userRolesForCheckbox"
              native-value="Sales Staff"
              size="is-small"
            >
              Sales Staff
            </b-checkbox>
            <b-checkbox
              v-model="userRolesForCheckbox"
              native-value="Sales & Pull Out/Return Staff"
              size="is-small"
            >
              Sales & Pull Out/Return Staff
            </b-checkbox>
            <b-checkbox
              v-model="userRolesForCheckbox"
              native-value="Sales & Technical Admin"
              size="is-small"
            >
              Sales & Technical Admin
            </b-checkbox>
            <b-checkbox
              v-model="userRolesForCheckbox"
              native-value="Sales & P.O Staff"
              size="is-small"
            >
              Sales & P.O Staff
            </b-checkbox>
            <b-checkbox
              v-model="userRolesForCheckbox"
              native-value="Technical Staff"
              size="is-small"
            >
              Technical Staff
            </b-checkbox>
            <b-checkbox
              v-model="userRolesForCheckbox"
              native-value="Delivery Staff"
              size="is-small"
            >
              Delivery Staff
            </b-checkbox>
            <b-checkbox
              v-model="userRolesForCheckbox"
              native-value="Logistic Staff"
              size="is-small"
            >
              Logistic Staff
            </b-checkbox>
            <b-checkbox
              v-model="userRolesForCheckbox"
              native-value="Accounting Staff"
              size="is-small"
            >
              Accounting Staff
            </b-checkbox>
            <b-checkbox
              v-model="userRolesForCheckbox"
              native-value="Logistic & Accounting"
              size="is-small"
            >
              Logistic & Accounting
            </b-checkbox>
          </div>
          <span class="has-text-warning">
            <i>{{ updateNote }}</i>
          </span>
        </div>
        <div class="columns">
          <div class="column is-12">
            <label class="label is-small"
              >Agent's signature (Required dimensions 300x300)</label
            >
            <div class="control">
              <span v-if="signaturePreview">
                <img
                  :src="signaturePreview"
                  width="300"
                  height="300"
                  border="1"
                />
              </span>
              <span v-else>
                <span v-if="isLoadingImage">
                  <img
                    src="../../assets/loading.gif"
                    width="200"
                    height="200"
                    border="1"
                  />
                </span>
              </span>
              <br />
              <input
                type="file"
                @change="fileChange($event.target.files)"
                ref="signatureImageInput"
              />
            </div>
          </div>
        </div>
        <div style="float: right">
          <button :class="successButton" @click="saveUser">
            <span class="icon">
              <i class="fas fa-save"></i>
            </span>
            &nbsp; Save
          </button>
          &nbsp;
          <router-link to="/user-managements" class="button is-small">
            <span class="icon"> <i class="fas fa-arrow-left"></i> </span>&nbsp;
            Go back to list</router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import AppToast from "../frontend/appToast";
import AppButton from "../frontend/appButton";

const appToast = new AppToast();
const appButton = new AppButton();

export default {
  data() {
    return {
      // signature
      userSignature: new FormData(),
      isLoadingImage: false,
      signaturePreview: null,
      user: {
        userRoles: []
      },
      userRolesForCheckbox: [],
      isCreate: true,

      replacePass: {},
      replaceEmailPass: {},

      updateNote: "",

      successButton: appButton.isLoadingSuccess(false),
      createOrUpdate: "Create",
      isFullPage: true,
      isLoading: false
    };
  },
  methods: {
    fileChange(file) {
      for (let i = 0; i < file.length; i++) {
        this.userSignature.append("user", file[i], file[i].name);
      }

      this.signaturePreview = URL.createObjectURL(file[0]);
    },
    default() {
      this.user = {
        userRoles: []
      };
      this.updateNote = "";
      this.$router.push("/user-managements");
    },
    replacePassword() {
      const userId = this.$route.params.userId;
      if (userId) {
        this.replacePass.id = userId;
        axios
          .post(`api/users/replace-pass/`, this.replacePass)
          .then(response => {
            appToast.success(response.data);
          })
          .catch(error => {
            appToast.danger(error);
          });
      }
    },
    replaceEmailPassword() {
      const userId = this.$route.params.userId;
      if (userId) {
        this.replaceEmailPass.id = userId;
        axios
          .post("api/users/replace-email-pass", this.replaceEmailPass)
          .then(response => {
            appToast.success(response.data);
          })
          .catch(error => {
            appToast.danger(error);
          });
      }
    },
    saveUser() {
      if (!this.user) {
        return false;
      }
      this.successButton = appButton.isLoadingSuccess(true);
      this.user.userRoles = this.userRolesForCheckbox.map(role => ({ role }));
      const userId = this.$route.params.userId;

      if (this.user.userRoles.length > 1) {
        appToast.danger("Single role is allowed.");
        return false;
      }

      if (userId) {
        // update
        this.user.id = userId;

        axios
          .put(`api/users/${this.user.id}`, this.user)
          .then(response => {
            appToast.success(response.data);
            if (this.$refs.signatureImageInput.value) {
              const user = {
                userId: this.user.id
              };
              this.saveSignature(user);
            }
            this.updateNote =
              "Note: Role changes will take effect after this user is re-logging in";
          })
          .catch(error => {
            appToast.danger(error.response.data);
          })
          .then(() => {
            this.successButton = appButton.isLoadingSuccess(false);
          });
      } else {
        // create
        axios
          .post("api/users", this.user)
          .then(response => {
            const userId = response.data;
            if (userId != 0) {
              appToast.success("Successfully registered");
              if (this.$refs.signatureImageInput.value) {
                const user = {
                  userId: userId
                };
                this.saveSignature(user);
              }
            } else {
              appToast.danger("Failed to register. Something went wrong");
            }
          })
          .catch(error => {
            appToast.danger(error.response.data);
          })
          .then(() => {
            this.successButton = appButton.isLoadingSuccess(false);
          });
      }
    },
    saveSignature(user) {
      this.userSignature.append("userDetail", JSON.stringify(user));
      axios
        .post(`api/users/upload-signature`, this.userSignature)
        .then(response => {
          if (response.data) {
            appToast.success("Signature has been successfully saved");
          } else {
            appToast.danger("Something went wrong. Failed to upload signature");
          }
        })
        .catch(error =>
          appToast.danger("Something went wrong. Failed to upload signature")
        )
        .then(() => {
          this.$refs.signatureImageInput.value = "";
          this.signaturePreview = null;
          this.userSignature = new FormData();

          const userId = this.$route.params.userId;
          if (userId) {
            this.getUserById(userId);
          }
        });
    },
    getUserById(userId) {
      axios
        .get(`api/users/${userId}`)
        .then(response => {
          this.user = response.data;
          this.userRolesForCheckbox = this.user.userRoles.map(
            ({ role }) => role
          );

          axios
            .get(`api/users/get-signature/${userId}`)
            .then(response => {
              this.signaturePreview = `data:image/png;base64, ${response.data}`;
            })
            .catch(error =>
              appToast.danger("Failed fetching signature. Something went wrong")
            )
            .then(() => {
              this.isLoadingImage = false;
            });

          this.isCreate = false;
        })
        .catch(error => {
          appToast.danger("Something went wrong. Redirecting to list of users");
          console.log(error);
          this.$router.push("/user-managements");
        })
        .then(() => {
          this.isLoading = false;
        });
    }
  },
  created() {
    const userId = this.$route.params.userId;
    if (userId) {
      this.isLoading = true;
      this.isLoadingImage = true;
      this.createOrUpdate = "Update";

      this.getUserById(userId);
    }
  }
};
</script>
